// T-1 / T-3 / T-4 / T-5 工具箱接口
import request, { normalizeError } from './request';

// PDF 工具：/api/tools/pdf/{action}
// action: merge / split / extract / delete / reorder / rotate / compress /
//         watermark / encrypt / decrypt / extract_images / extract_text
export function pdfTool(action, form) {
  return request.post(`/api/tools/pdf/${action}`, form, { timeout: 120000 });
}

// 图片工具：/api/tools/image/{action}
// action: compress / resize / crop / watermark / to_pdf
export function imageTool(action, form) {
  return request.post(`/api/tools/image/${action}`, form, { timeout: 120000 });
}

// 编码工具：/api/tools/codec（action + 参数）
export function codecTool(action, params = {}) {
  return request.post('/api/tools/codec', { action, ...params }, { timeout: 30000 });
}

// OCR 识别：/api/tools/ocr（form: file + target，target ∈ docx/txt/html/md/json）
// 扫描件识别耗时较长（按页数），超时给足 10 分钟
export function ocrTool(form) {
  return request.post('/api/tools/ocr', form, { timeout: 600000 });
}

export { normalizeError };
